import { put, SagaIterator, select, takeEveryErrorRequest } from './core/sagaEffects';
import { AddNotification } from 'acscp/actions';
import { QuoteAcceptRequest } from 'acscp/api/requests';
import { ResponseErrorTypes, ResponseType } from 'acscp/api/responses/core/responseTypes';
import { ErrorDetails } from 'acscp/api/models/errorDetails';
import history from 'acscp/store/history';
import { AppState } from 'acscp/store';
import { getTranslatableErrorMessage } from 'acscp/components/common/helpers/getTranslatableErrorMessage';
import { NotificationType } from 'acscp/store/notificationState';
import { chartersList } from 'acscp/components/routeHelper';

export function* acceptQuoteNotificationSaga(): SagaIterator {
    // We only add special handling to 4** errors.
    // The default error handling of 500 errors (i.e. simply adding a notification)
    // is the desired behaviour in this case: no need to redirect the user,
    // because they might be able to "fix" the problem by retrying.
    yield takeEveryErrorRequest(QuoteAcceptRequest, handleQuoteAcceptErrors);
}

const acceptQuoteFailedCause = 'AcceptQuoteFailedCause';

function quoteBookingIdSelector(state: AppState, quoteId: string): string | null {
    const quote = state.quotes.quotesList[quoteId];
    return quote ? quote.bookingId : null;
}

export function* handleQuoteAcceptErrors(
    responseType: ResponseErrorTypes,
    error: ErrorDetails,
    request: QuoteAcceptRequest
): SagaIterator {
    // Each 4** errors that server may return for the quote accept request
    // mean that the quote can not possibly be accepted for some reason.
    // We redirect the user to the booking page to see the updated state,
    // so they could reconsider their options.

    if (responseType === ResponseType.Conflict) {
        // Conflict errors have additional helpful information - show it.
        yield put(new AddNotification(
            acceptQuoteFailedCause, getTranslatableErrorMessage(error.message), NotificationType.Error));
    }

    const bookingId = (yield select(quoteBookingIdSelector, request.quoteId)) as unknown as string | null;
    const redirect = bookingId ? `/trip/${bookingId}` : chartersList();

    history.push(redirect);
}
